import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api, apiError } from "../lib/api";
import { useLang } from "../i18n";
import { useAuth } from "../context/AuthContext";
import Seo from "../components/Seo";
import { Reveal, GoldButton } from "../components/motion";
import { toast } from "sonner";

export default function Auth({ mode }) {
  const { t, lang } = useLang();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [isLogin, setIsLogin] = useState(mode !== "register");
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const r = isLogin
        ? await api.post("/auth/login", { email: form.email, password: form.password })
        : await api.post("/auth/register", form);
      login(r.data.access_token, r.data.user);
      navigate(`/${lang}${params.get("next") || "/account"}`);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="pt-[72px] min-h-[90vh] flex items-center">
      <Seo title={`${isLogin ? t("auth.loginTitle") : t("auth.registerTitle")} — Chef à Domicile`} description={t("seo.homeDesc")} />
      <div className="max-w-[440px] mx-auto w-full px-4 py-20">
        <Reveal>
          <h1 className="font-serif text-4xl text-ivory text-center mb-10">{isLogin ? t("auth.loginTitle") : t("auth.registerTitle")}</h1>
          <form onSubmit={submit} className="bg-coal border border-white/8 p-8 space-y-5" data-testid="auth-form">
            {!isLogin && (
              <div>
                <label className="lux-label">{t("auth.name")}</label>
                <input data-testid="auth-name-input" required className="lux-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
              </div>
            )}
            <div>
              <label className="lux-label">{t("auth.email")}</label>
              <input data-testid="auth-email-input" required type="email" className="lux-input" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
            </div>
            <div>
              <label className="lux-label">{t("auth.password")}</label>
              <input data-testid="auth-password-input" required type="password" minLength={8} className="lux-input" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
            </div>
            <GoldButton type="submit" disabled={sending} data-testid="auth-submit-btn" className="w-full">
              {sending ? t("common.sending") : isLogin ? t("auth.loginBtn") : t("auth.registerBtn")}
            </GoldButton>
            <button type="button" data-testid="auth-switch-btn" onClick={() => setIsLogin(!isLogin)}
              className="block w-full text-center text-sm text-neutral-400 hover:text-gold transition-colors pt-2">
              {isLogin ? t("auth.toRegister") : t("auth.toLogin")}
            </button>
          </form>
        </Reveal>
      </div>
    </div>
  );
}
